export const PAGE_IDS = {
  Spark: 'spark',
  Overview: 'overview',
  Dashboards: 'dashboards',
  Charts: 'charts',
  AIHighlights: 'ai-highlights',
  Alerts: 'alerts',
  Subscriptions: 'subscriptions',
  DataSource: 'data-source',
  Schedules: 'liveboard-schedules',
  Pulse: '/pulse',
  Search: 'search',
  SupportAccess: 'support-access',
  Datasets: 'datasets',
  Data: 'data',
  Sources: 'sources',
  QuestionLabels: 'question-labels',
} as const;
